import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import Grid from "@mui/material/Grid";
import TableContainer from "@mui/material/TableContainer";
import React, {useState, SyntheticEvent} from "react";
import {v4} from "uuid";
import CreateIcon from "@mui/icons-material/Create";
import AddIcon from "@mui/icons-material/Add";
import bloodmagic_items from "../../_data/bloodmagic_items";
import HelpOutlineSharpIcon from "@mui/icons-material/HelpOutlineSharp";
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import Stack from "@mui/material/Stack";
import {s_char, s_char_bloodmagicitems} from "../../_signals/s_char";
import {ICharBloodMagicItem} from "../../_interfaces/ICharBloodMagicItem";
import {InfoBloodmagicItemBehaveSubscriber} from "../../_helper/InfoBloodmagicItemBehave";
import {ICharMod} from "../../_interfaces/ICharMod";
import {ModsAdd, ModsSourceDelete} from "../../_api/BEMods";
import {BloodMagicItemDelete, BloodMagicItemUpdate} from "../../_api/BEBloodMagicItems";
import {useSignals} from "@preact/signals-react/runtime";
import {BloodMagicSubscriber} from "../../_helper/DataBehaves";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import BloodMagicItemsAdd from "./BloodMagicItemsAdd";
import BloodMagicItemsEdit from "./BloodMagicItemsEdit";
import {s_app_rid} from "../../_signals/s_app";

export default function BloodMagicItems() {

    useSignals()
    const [addBloodmagic, setAddBloodmagic] = useState(false)
    const [editBloodmagic, setEditBloodmagic] = useState<ICharBloodMagicItem | null>(null)

    const remove = (bloodmagic: ICharBloodMagicItem) => {
        s_char_bloodmagicitems.value = s_char_bloodmagicitems.value.filter(bm => {
            if (bm.id === bloodmagic.id) {
                // TODO remove bschaden? wie wird der momentan verwaltet
                BloodMagicItemDelete(bm)
                return false
            }
            return bm
        })
    }


    const deactivate = (bloodmagic: ICharBloodMagicItem) => {

        s_char_bloodmagicitems.value = s_char_bloodmagicitems.value.map(bm => {
            if (bm.id === bloodmagic.id) {
                bm.active = false;
                BloodMagicItemUpdate(bm)
            }
            return bm
        })

        const bloodmagicitem = BloodMagicSubscriber.value.find(i => i.name === bloodmagic.name)

        if (bloodmagicitem && bloodmagicitem.strain_mods && bloodmagicitem.strain_mods.length > 0) {
            ModsSourceDelete(s_char.value.id, s_app_rid.value,'bloodmagic', bloodmagic.id)
        }
    }

    const activate = (bloodmagic: ICharBloodMagicItem) => {

        s_char_bloodmagicitems.value = s_char_bloodmagicitems.value.map(bm => {
            if (bm.id === bloodmagic.id) {
                bm.active = true;
                BloodMagicItemUpdate(bm)
            }
            return bm
        })

        const bloodmagicitem = BloodMagicSubscriber.value.find(i => i.name === bloodmagic.name)

        if (bloodmagicitem && bloodmagicitem.strain_mods && bloodmagicitem.strain_mods.length > 0) {
            let mods: ICharMod[] = [];
            for (let i = 0; i < bloodmagicitem.strain_mods.length; i++) {
                const smod = bloodmagicitem.strain_mods[i]
                mods.push({
                    id: v4(),
                    cid: s_char.value.id,
                    msourceid: bloodmagic.id,
                    sl: false,
                    strain: bloodmagic.strain,
                    msource: 'bloodmagic',
                    mfrom: bloodmagic.name,
                    what: smod.what,
                    mmod: smod.mod,
                    type: 'rounds',
                    duration: 1,
                    disabled: true
                })
            }
            if (mods.length > 0) ModsAdd(s_char.value.id, s_app_rid.value,mods)
        }
    }


    const handlePopOpen = (name: string, event: SyntheticEvent) => {
        let bloodmagic = bloodmagic_items.find((s) => s.name === name);
        if (bloodmagic) InfoBloodmagicItemBehaveSubscriber.next({
            popOpen: true,
            popEl: event.currentTarget,
            pop: bloodmagic
        })
    }

    const bloodmagicRow = (row: ICharBloodMagicItem) => {
        return <TableRow key={row.id}>
            <TableCell style={{width: '80%', verticalAlign: 'top'}}>
                <Stack direction={'row'} style={{width: "100%"}} justifyContent="space-between">
                    <div>
                        {row.name}
                        {row.descr ? <div style={{fontStyle: 'italic'}}>Bem: {row.descr}</div> : null}
                        {row.state === 0 ? <div style={{fontStyle: 'italic'}}>ungebunden</div> : null}
                        {row.state === 1 ? <div style={{fontStyle: 'italic'}}>bebunden</div> : null}
                        {row.state === 2 ? <div style={{fontStyle: 'italic'}}>benutzt</div> : null}
                    </div>
                </Stack>
            </TableCell>
            <TableCell style={{width: '15%', paddingRight: 0}}>
                <Grid container spacing={2} direction={'row'}>
                    <Grid item>
                        <Button onClick={(e) => handlePopOpen(row.name, e)}>
                            <HelpOutlineSharpIcon/>
                        </Button>
                    </Grid>
                    <Grid item>
                        {row.state === 1 && row.strain > 0 ? row.active ?
                                <Button onClick={() => deactivate(row)}>
                                    <ToggleOnIcon/>
                                </Button>
                                :
                                <Button onClick={() => activate(row)}>
                                    <ToggleOffIcon style={{color: 'lightgray'}}/>
                                </Button>
                            :
                            null
                        }
                    </Grid>
                    <Grid item>
                        <Button className={'btn'} id="post" onClick={() => remove(row)}>
                            <DeleteOutlineIcon/>
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button onClick={() => setEditBloodmagic(row)}>
                            <CreateIcon/>
                        </Button>
                    </Grid>
                </Grid>
            </TableCell>
        </TableRow>
    }


    return <Paper style={{overflowX: 'auto', marginTop: "14px"}}>
        <h3 style={{margin: "5px",display:'flex',justifyContent:'space-between'}}>
            <span>Blutamulette</span>
            <AddIcon onClick={() => setAddBloodmagic(true)}/>
        </h3>
        <TableContainer style={{maxHeight: 185}}>
            <Table stickyHeader style={{width: '100%'}}>
                <TableBody>
                    {s_char_bloodmagicitems.value.map((row) => bloodmagicRow(row))}
                </TableBody>
            </Table>
        </TableContainer>
        {addBloodmagic ? <BloodMagicItemsAdd open={addBloodmagic} isOpen={(e) => setAddBloodmagic(false)}/> : null}
        {editBloodmagic ? <BloodMagicItemsEdit open={editBloodmagic} isOpen={(e) => setEditBloodmagic(null)}/> : null}
    </Paper>
}
